import React    from 'react';

class StatusSelector extends React.Component {

    static propTypes = {
        userName: React.PropTypes.string
    };

    render() {
        const { userName } = this.props;
        return (

            <div className="select">
                <span className="select__name">{ userName }</span>
                <div className="select__item">
                    <select className="select__field" name="" id="">
                        <option value="at_home">at home</option>
                        <option value="good_night">good night</option>
                        <option value="on_holidays">on holidays</option>
                        <option value="away">away</option>
                    </select>
                </div>
            </div>

        );
    }
}

export default StatusSelector;



// WEBPACK FOOTER //
// ./app/components/controls/statusSelector/StatusSelector.jsx